import { linkToClassPage } from "../../routes/teacher/routes/class/links";
import { linkToEditClassAssignment } from "../../routes/teacher/routes/class/routes/edit-assignment/links";

// Create journey

export function linkToCreateAssignmentJourney(classId?: string) {
  return `${linkToClassPage(classId)}/create-assignment`;
}

export function linkToCreateAssignmentJourneySelectType(classId?: string) {
  return `${linkToCreateAssignmentJourney(classId)}/type`;
}

export function linkToCreateAssignmentJourneySelectTopics(classId?: string) {
  return `${linkToCreateAssignmentJourney(classId)}/topics`;
}

export function linkToCreateAssignmentJourneyExamQuestions(classId?: string) {
  return `${linkToCreateAssignmentJourney(classId)}/exam-questions`;
}

export function linkToCreateAssignmentJourneyDetailsPage(classId?: string) {
  return `${linkToCreateAssignmentJourney(classId)}/details`;
}

export function linkToCreateAssignmentJourneyInviteParentsPage(
  classId?: string
) {
  return `${linkToCreateAssignmentJourney(classId)}/invite-parents`;
}

// Edit journey

export function linkToEditAssignmentJourney(
  classId?: string,
  assignmentId?: string
) {
  return linkToEditClassAssignment(classId, assignmentId);
}

export function linkToEditAssignmentJourneyDetailsPage(
  classId?: string,
  assignmentId?: string
) {
  return `${linkToEditAssignmentJourney(classId, assignmentId)}/details`;
}

export function linkToEditAssignmentJourneyExamQuestions(
  classId?: string,
  assignmentId?: string
) {
  return `${linkToEditAssignmentJourney(classId, assignmentId)}/exam-questions`;
}
